import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
import { openCalendlyPopup } from '../utils/calendly';
import { HomeIcon, BookOpenIcon, PhoneIcon, ArrowRightIcon } from 'lucide-react';
export function NotFoundPage() {
  const {
    language
  } = useLanguage();
  const content = {
    de: {
      badge: "Hier gibt's nichts zu finden 🤷",
      title: '404 – Seite nicht gefunden',
      subtitle: 'Wonach hast Du gesucht? Unsere wichtigsten Links:',
      cards: [{
        title: 'Zur Startseite',
        description: 'Zurück zur Hauptseite mit allen Informationen über CRM Kraft',
        buttonText: 'Zur Startseite',
        link: '/',
        icon: HomeIcon
      }, {
        title: 'Blog & Ressourcen',
        description: 'Praxiserprobte CRM-Strategien und Vertriebstipps für mehr Umsatz',
        buttonText: 'Zum Blog',
        link: '/blog',
        icon: BookOpenIcon
      }, {
        title: 'Kostenloses Erstgespräch',
        description: 'Lass uns analysieren, wie wir Dein CRM-System optimieren können',
        buttonText: 'Jetzt Termin buchen',
        action: 'calendly',
        icon: PhoneIcon
      }],
      helpText: 'Immer noch nicht gefunden, wonach Du suchst?',
      backHome: 'Zurück zur Startseite'
    },
    en: {
      badge: 'Nothing to find here 🤷',
      title: '404 – Page Not Found',
      subtitle: 'What were you looking for? Our most important links:',
      cards: [{
        title: 'Back to Home',
        description: 'Return to the main page with all information about CRM Kraft',
        buttonText: 'Go to Home',
        link: '/',
        icon: HomeIcon
      }, {
        title: 'Blog & Resources',
        description: 'Proven CRM strategies and sales tips for more revenue',
        buttonText: 'Go to Blog',
        link: '/blog',
        icon: BookOpenIcon
      }, {
        title: 'Free Consultation',
        description: "Let's analyze how we can optimize your CRM system",
        buttonText: 'Book Appointment',
        action: 'calendly',
        icon: PhoneIcon
      }],
      helpText: "Still haven't found what you're looking for?",
      backHome: 'Back to Home'
    }
  };
  const t = content[language];
  return <div className="min-h-screen bg-[#0a0e1a] flex flex-col" data-id="element-669">
      <Navigation data-id="element-670" />

      <main className="flex-1 pt-24 pb-16 px-4" data-id="element-671">
        <div className="max-w-6xl mx-auto" data-id="element-672">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-673">
            <div className="inline-block bg-[#ff6b35]/10 border border-[#ff6b35]/20 rounded-full px-4 py-2 mb-6" data-id="element-674">
              <span className="text-[#ff6b35] text-sm font-medium" data-id="element-675">
                {t.badge}
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4" data-id="element-676">
              {t.title}
            </h1>

            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-677">
              {t.subtitle}
            </p>
          </div>

          {/* Action Cards */}
          <div className="grid md:grid-cols-3 gap-6 lg:gap-8" data-id="element-678">
            {t.cards.map((card, index) => <div key={index} className="bg-gradient-to-br from-[#1a1f36] to-[#111827] rounded-xl border border-white/10 p-8 flex flex-col" data-id="element-679">
                {/* Icon */}
                <div className="w-14 h-14 bg-[#ff6b35]/10 rounded-lg flex items-center justify-center mb-6" data-id="element-680">
                  <card.icon className="w-7 h-7 text-[#ff6b35]" data-id="element-681" />
                </div>

                {/* Content */}
                <h2 className="text-2xl font-bold text-white mb-3" data-id="element-682">
                  {card.title}
                </h2>
                <p className="text-gray-400 mb-6 flex-1" data-id="element-683">{card.description}</p>

                {/* Button */}
                {card.link ? <Link to={card.link} className="inline-flex items-center justify-center gap-2 bg-[#ff6b35] hover:bg-[#ff5722] text-white px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-684">
                    {card.buttonText}
                    <ArrowRightIcon className="w-5 h-5" data-id="element-685" />
                  </Link> : <button onClick={openCalendlyPopup} className="inline-flex items-center justify-center gap-2 bg-[#ff6b35] hover:bg-[#ff5722] text-white px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-686">
                    {card.buttonText}
                    <ArrowRightIcon className="w-5 h-5" data-id="element-687" />
                  </button>}
              </div>)}
          </div>

          {/* Additional Help Section */}
          <div className="mt-16 text-center" data-id="element-688">
            <p className="text-gray-500 mb-4" data-id="element-689">{t.helpText}</p>
            <Link to="/" className="inline-flex items-center gap-2 text-[#ff6b35] hover:text-[#ff5722] font-medium transition-colors" data-id="element-690">
              <HomeIcon className="w-5 h-5" data-id="element-691" />
              {t.backHome}
            </Link>
          </div>
        </div>
      </main>

      <Footer data-id="element-692" />
    </div>;
}